import { render, staticRenderFns } from "./Borden.vue?vue&type=template&id=3a8ab259&scoped=true&"
import script from "./Borden.vue?vue&type=script&lang=js&"
export * from "./Borden.vue?vue&type=script&lang=js&"
import style0 from "./Borden.vue?vue&type=style&index=0&id=3a8ab259&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ab259",
  null
  
)

export default component.exports